<template>
  <el-form
    :model="model"
  >
    <div class="row">
      <div class="col-lg-6 col-sm-8 col-12">
        <el-form-item
          prop="entryDateYear"
          :label="L10n('condition')"
          class="material-style"
        >
          <select-response
            :model="model.conditionID"
            @update:model="updateModelItem('conditionID', $event)"
            :data="dataSourceCondition.records"
            :isLoading="dataSourceCondition.isLoading"
            multiple
            :clearable="false"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'LayoutStatisticsFilters',
  props: {
    model: { type: Object, required: true }
  },
  computed: {
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    }
  },
  methods: {
    updateModelItem (fieldName, value) {
      this.$emit('update:model', Object.assign({}, this.model, { [fieldName]: value }))
      this.$emit('on-filter')
    }
  }
}
</script>
